import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class FabricatorPresenter extends EntityPresenter {
  static urn = 'fabricators'
  static key = 'fabricator'

  static navOptions(key = 'fabricators') {

    const routes = {
      fabricators: {
        icon: 'brunch_dining',
        pageRoutes: ['fabricator'],
      }
    }
    return routes[key]
  }
}

bindPresenterMethods(FabricatorPresenter)
